const { height } = require('tailwindcss/defaultTheme')

module.exports = {
  ...height,
  '250': '250px',
}
